export const tempUserInfo = state => state.authReducer.tempUserInfo
